// src/components/admin/TierBadge.jsx
//
// Tiny visual pill for rendering a club's commercial tier. Reused by
// AdminClubsList (table cells) and AdminClubDetail (header summary).
// Founding clubs render with a small "founding" marker if their
// foundingClubNumber is set.

import React from 'react';

const TIER_LABEL = {
  free:           'Free',
  team:           'Team',
  club:           'Club',
  growth:         'Growth',
  elite:          'Elite',
  enterprise:     'Enterprise',
  founding_club:  'Founding',
};

export default function TierBadge({ tier, foundingClubNumber }) {
  if (!tier) {
    return <span className="text-zinc-400">—</span>;
  }
  const label = TIER_LABEL[tier] || tier;
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="inline-block px-2 py-0.5 rounded-full text-xs font-semibold bg-lime-100 text-lime-900 border border-lime-200">
        {label}
      </span>
      {foundingClubNumber != null && (
        <span
          className="inline-block px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-zinc-900 text-lime-300"
          title={`Founding Club #${foundingClubNumber}`}
        >
          FC#{foundingClubNumber}
        </span>
      )}
    </span>
  );
}
